import { filterBy } from '@integration-frontends/common/utils/collection';
import { AbsoluteDimensions, MediaType, Offsets } from '../../common';
import { ResourceBase, ResourceType } from '../resource-base';
import { AttachmentDto } from '@integration-frontends/common/brandfolder-api';

export enum AttachmentOrientation {
  Horizontal,
  Vertical,
  Square,
  Panoramic,
}

export enum AttachmentUploadDate {
  All = 'ALL',
  Last30Minutes = 'LAST_30_MINUTES',
  Past24Hours = 'PAST_24_HOURS',
  Past7Days = 'PAST_7_DAYS',
  DateRange = 'DATE_RANGE',
}

export interface Attachment extends ResourceBase {
  type: ResourceType.ATTACHMENT;
  url: string;
  filename: string;
  extension: string;
  mimetype: string; // TODO: derive this from mediaType
  assetId: string;
  thumbnailUrl: string;
  dimensions: AbsoluteDimensions;
  mediaType: MediaType;
  supported: boolean;
  sizeInBytes: number;
  updatedAt: Date;
  createdAt: Date;
  isProcessing: boolean;
  dto?: AttachmentDto;
}

export const filterByAsset = filterBy('assetId');
export function getAttachmentUrl(attachment: Attachment | AttachmentVariant): string {
  return attachment.url;
}

export interface AttachmentVariant extends Omit<Attachment, 'type'> {
  type: ResourceType.ATTACHMENT_VARIANT;
  attachmentId: string;
}

export interface AttachmentTransforms {
  crop?: AbsoluteDimensions & Offsets;
  size?: AbsoluteDimensions;
  mediaType?: MediaType;
}
